import { Backdrop, CircularProgress, useTheme } from '@mui/material'
import { NAV_LAYOUT_MARGIN_START } from '../consts/nav-layout-margin'

export default function FullPageProgress ({ isOpen, isMobile, isFormOpen }) {
  const theme = useTheme()
  const { formDrawerWidth } = theme.mixins
  const respMarginInlineStart = isMobile
    ? 0
    : isFormOpen
      ? `calc(${NAV_LAYOUT_MARGIN_START} + ${formDrawerWidth}px)`
      : NAV_LAYOUT_MARGIN_START

  return (
    <Backdrop
      sx={{ marginInlineStart: respMarginInlineStart, zIndex: theme.zIndex.drawer + 10 }}
      open={isOpen}
    >
      <CircularProgress size={100} />
    </Backdrop>
  )
}
